import ListLayout from "../../../components/layout/main/ListLayout"
import TransferList from "../../../components/main/setting/transfer/TransferList"
import TransferSetting from "../../../components/main/setting/transfer/TransferSetting"
import { PageCard } from "../../../styles/CommonStyles"



const TransferSettings = () => {

    return (
        <ListLayout>
            <PageCard>
                <TransferSetting />
                <TransferList />
            </PageCard>
        </ListLayout>
    )
}



export default TransferSettings